import * as S from './styles';
import { Controller, FieldErrors, UseFormRegister } from "react-hook-form";
import { IMaskInput } from "react-imask";
import ReactLoading from "react-loading";
//Interface
import { Inputs } from 'Interfaces/ICustomerAddress';
import { useEffect, useState } from 'react';
import { checkCEP } from 'utils/CheckCEP';
//Icons
import { MagnifyingGlass } from "@phosphor-icons/react";

interface IProps {
  register: UseFormRegister<Inputs>;
  errors: FieldErrors<Inputs>;
  setValue: any,
  control: any
}
export default function FormsAddress({
  errors,
  register,
  setValue,
  control
}: IProps) {

  const [dataAddress, setDataAddress] = useState<any>(null);
  const [inputValue, setInputValue] = useState('');
  const [isLoadSearch, setIsLoadSearch] = useState(false);

  useEffect(() => {
    try {
      if (dataAddress) {
        setValue('street', dataAddress.address_name || '');
        setValue('neighborhood', dataAddress.district || '');
        setValue('city', dataAddress.city || '');
        setValue('uf', dataAddress.state || '');
      }
    } catch (e) {
      console.log('error');
    }
  }, [dataAddress, setValue]);

  return (
    <S.Container>
      <S.FormInput>
        <S.Label>
          CEP
          {/* <span>*</span> */}
        </S.Label>
        <S.ContentInput>
          <Controller
            name="cep"
            control={control}
            render={({ field }) => (
              <IMaskInput
                id="cep"
                mask="00.000-000"
                placeholder="00.000-000"
                onAccept={(value: string) => {
                  field.onChange(value);
                  setInputValue(value);
                }}
                {...field}
                inputRef={field.ref}
              />

            )}
          />
          {/* //Pesquisar */}
          <S.ButtonIcon
            onClick={() => checkCEP(inputValue, setDataAddress, setIsLoadSearch)}>
            {isLoadSearch ? (
              <ReactLoading
                type="spokes"
                color="red"
                height="20px"
                width="20px"
              />
            ) : (
              <MagnifyingGlass size={20} />
            )}
          </S.ButtonIcon>
        </S.ContentInput>
        {errors.cep && (
          <S.InforErro>Campo Obrigatório</S.InforErro>
        )}
      </S.FormInput>

      <S.SeparateDiv>
        <S.FormInput>
          <S.Label>Cidade</S.Label>
          <S.Input
            type="text"
            placeholder="Informe a cidade"
            {...register("city")} />
        </S.FormInput>

        <S.FormInput>
          <S.Label>UF</S.Label>
          <S.Input type="text" placeholder="AM" {...register("uf")} />
        </S.FormInput>
      </S.SeparateDiv>

      <S.FormInput>
        <S.Label>Rua</S.Label>
        <S.Input type="text" placeholder="Informe a rua" {...register("street")} />
      </S.FormInput>

      <S.SeparateDiv>
        <S.FormInput>
          <S.Label>Bairro</S.Label>
          <S.Input type="text" placeholder="Informe a cidade" {...register("neighborhood")} />
        </S.FormInput>

        <S.FormInput>
          <S.Label>N°</S.Label>
          <S.Input type="text" placeholder="xxxx" {...register("number")} />
        </S.FormInput>
      </S.SeparateDiv>

      <S.FormInput>
        <S.Label>Referência</S.Label>
        <S.Input type="text" placeholder="Campo opcional" {...register("reference")} />
      </S.FormInput>

      <S.FormInput>
        <S.Label>Complemento</S.Label>
        <S.Input type="text" placeholder="Campo opcional" {...register("complement")} />
      </S.FormInput>
    </S.Container>
  )
}